import { Category, ResponseGetCategories } from "@CommonApi/categories";
import { omniAtom } from "src/utils/atoms";

export const addCategoryModalAtom = omniAtom({
  key: "modals/addCategory",
  value: null as null | {
    categories: ResponseGetCategories;
    category?: Category;
    onSaved?: () => void;
  },
});
